var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{style:(_vm.styleProp)},[_c('v-spacer'),_c('v-btn',{attrs:{"flat":"","value":"recent"},on:{"click":function($event){return _vm.decrement()}}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.increment()}}},[_c('v-icon',[_vm._v("mdi-arrow-right")])],1),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }